import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function LoginButton({className = "btn btn-primary"}) {
  const { loginWithRedirect } = useAuth0();

  return (
      <button className={className} onClick={() => loginWithRedirect()}>
        Sign in
      </button>
  )

};
